import { log } from "./log";
import { client } from "./supabase"; // Import the actual client from your supabase file

export const login = async ({ email, pais, senderEmail, isLocalhost }) => {
  try {
    const { data: result, error } = await client.functions.invoke("hyper-function", {
      body: { email, pais, senderEmail, isLocalhost },
    });

    if (error) {
      log.error("login", error);
      return { success: false, error: "unexpected" };
    }

    return result; // {success: true} or {success: false, error: 'invalid_email'}
  } catch (error) {
    log.error("login", error);
    return { success: false, error: "unexpected" };
  }
};

export const verifyOTP = async ({ email, code, pais }) => {
  try {
    const { data: result, error } = await client.functions.invoke("verify-otp", {
      body: { email, code, pais },
    });

    if (error) {
      log.error("verifyOTP", error);
      return { success: false, error: "unexpected" };
    }

    return result;
  } catch (error) {
    log.error("verifyOTP", error);
    return { success: false, error: "unexpected" };
  }
};
